const isInViewport = (elem, windowScrollPosition, offset = 0, targetBound = "top") => {
    return elem.offsetTop + offset <= windowScrollPosition[targetBound];
};

export function elementIsInViewPort(
    elementSelector,
    windowScrollPosition,
    offset = 0,
    targetBound = "top"
) {
    const element =
        typeof elementSelector === "string"
            ? document.querySelector(elementSelector)
            : elementSelector;
    if (!element) return false;
    return isInViewport(element, windowScrollPosition, offset, targetBound);
}
